import { render, staticRenderFns } from "./layout-product-card.vue?vue&type=template&id=ea7a63de&scoped=true&"
import script from "./layout-product-card.vue?vue&type=script&lang=js&"
export * from "./layout-product-card.vue?vue&type=script&lang=js&"
import style0 from "./layout-product-card.vue?vue&type=style&index=0&id=ea7a63de&lang=scss&scoped=true&"
import style1 from "./layout-product-card.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea7a63de",
  null
  
)

export default component.exports